module.exports = __webpack_public_path__ + "img/entrance_plant_3@2x.65cab3bc.jpg";